<template>
	<div>
		<BaseAccordionController
			class="volunteering-header-carousel"
			v-if="showList && dataloaded"
		>
			<template v-slot:select>
				<div class="select-area mx-2">
					<v-select
						v-model="selectedStatus"
						:items="statusOptions"
						item-value="value"
						:label="getStateWithParam('volunteering_select_label')"
					></v-select>
				</div>
			</template>
			<template v-slot:component>
				<v-container class="card-wrapper" grid-list-lg>
					<v-layout class="card-inner-wrapper" row wrap>
						<hooper
							class="hooper-navigation hooper-carousel"
							:playSpeed="3500"
							:itemsToShow="1.3"
							:centerMode="true"
							:wheelControl="false"
							:initialSlide="carouselIndex"
							ref="cardcarousel"
						>
							<slide
								v-for="(
									volunteering, index
								) in filteredVolunteeringList"
								:key="index"
								:index="index"
							>
								<Card
									:card_element="volunteering"
									class="card-item"
									@click.native="
										goToVolunteeringDetails(volunteering.id)
									"
								/>
							</slide>
							<hooper-pagination
								class="pagination-carousel my-2"
								slot="hooper-addons"
							></hooper-pagination>
						</hooper>
					</v-layout>
				</v-container>
				<div class="button-area">
					<v-btn
						class="volunteering-topic-form-button my-4"
						@click="goToVolunteeringTopicForm"
					>
						{{ getStateWithParam("volunteering_topic_form") }}
					</v-btn>
				</div>
			</template>
		</BaseAccordionController>
		<VolunteeringDetails
			v-if="showDetails || showForm"
			:showdetailsdialog="showDetails"
			:volunteeringId="volunteeringId"
		/>
	</div>
</template>

<script>
import { API_CLIENT_GET } from "@/config/api/api_call/service_instances";
import { VOLUNTEERING_LIST_URL } from "@/config/api/url/urls_in_app";

import Card from "./volunteering-card.vue";

import VolunteeringDetails from "../volunteering-details/Volunteering-details.vue";

import { Hooper, Slide, Pagination as HooperPagination } from "hooper";

export default {
	components: {
		Card,
		VolunteeringDetails,
		Hooper,
		Slide,
		HooperPagination,
	},
	data() {
		return {
			dataloaded: false,
			volunteeringlist: [],
			errorloading: false,
			activeSlide: 0,
			carouselIndex: 0,
			selectedStatus: "2",
			statusOptions: [], // Will be populated dynamically
		};
	},
	watch: {
		$route(to, from) {
			if (
				to.name === "volunteering_label" ||
				from.name === "volunteeringdetails"
			) {
				this.$store.state.active_loader = false;
			}
		},
	},
	created() {
		this.getList();
		this.populateStatusOptions();
	},
	computed: {
		showList() {
			return this.$route.name === "volunteeringmodule_label";
		},
		showDetails() {
			return this.$route.name === "volunteeringdetails";
		},
		showForm() {
			return this.$route.name === "volunteeringform";
		},
		volunteeringId() {
			return this.$route.params.id;
		},
		filteredVolunteeringList() {
			try {
				if (this.selectedStatus === "0") {
					return this.volunteeringlist || [];
				} else {
					return (this.volunteeringlist || []).filter(
						(volunteering) => {
							if (this.selectedStatus === "1") {
								return volunteering.periodStatus === "Past";
							} else if (this.selectedStatus === "2") {
								return (
									volunteering.periodStatus === "On-going" ||
									volunteering.periodStatus === "Upcoming"
								);
							} else {
								return false;
							}
						}
					);
				}
			} catch (error) {
				console.error(
					"An error occurred while filtering volunteering list:",
					error
				);
				return [];
			}
		},
	},
	methods: {
		getList() {
			API_CLIENT_GET(VOLUNTEERING_LIST_URL)
				.then((response) => {
					this.volunteeringlist = response.data;
					this.dataloaded = true;
					this.$store.state.active_loader = false;
					// this.setVolunteeringDetails();
				})
				.catch((err) => {
					this.errorloading = true;
					this.$store.state.active_loader = false;
				});
		},
		populateStatusOptions() {
			this.statusOptions = [
				{
					text: this.getStateWithParam("volunteering_select_all"),
					value: "0",
				},
				{
					text: this.getStateWithParam("volunteering_select_past"),
					value: "1",
				},
				{
					text: this.getStateWithParam(
						"volunteering_select_ongoing_upcoming"
					),
					value: "2",
				},
			];
		},
		goToVolunteeringTopicForm() {
			this.$router.push({ name: "volunteering_topic_form" });
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		goToVolunteeringDetails(volunteeringid) {
			this.carouselIndex = this.$refs.cardcarousel.currentSlide;
			this.$router.push({
				name: "volunteeringdetails",
				params: { id: volunteeringid },
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.card-wrapper {
	padding-top: 0;
	position: relative;
	max-width: 100%;
	.card-inner-wrapper {
		z-index: 3;
		position: relative;
		margin: -8px auto !important;
		@media only screen and (min-width: 960px) {
			max-width: 900px;
		}
	}
}
.card-item {
	display: flex;
	justify-content: center;
	align-items: center;
	max-width: 100%;
	border-radius: 10px;
	margin-top: 10px;
	overflow: hidden; /* Ensure that the card content doesn't overflow */
	box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); /* Add a subtle box shadow */
}

.button-area {
	display: flex;
	justify-content: center;
}
</style>

<style lang="scss">
.volunteering-header-carousel {
	.accordion-card-header {
		display: none !important;
	}
}

.volunteering-topic-form-button {
	display: flex;
	justify-content: center !important ; /* Horizontally center the button */
	align-items: center; /* Vertically center the button */
	background-color: #e60000 !important;
	margin: 0;
	border-radius: 5px;
}

.volunteering-topic-form-button button {
	display: flex !important;
	justify-content: center !important ; /* Horizontally center the button */
	align-items: center; /* Vertically center the button */
}

.volunteering-topic-form-button .v-btn__content {
	background-color: #e60000 !important;
	color: #ffffff !important;
	margin: 0 !important;
	padding-left: 10px;
	padding-right: 10px;
}

.hooper-carousel {
	margin-bottom: 30px;

	.pagination-carousel {
		display: flex !important;
		justify-content: center !important;
		position: relative;
		margin-top: 5px;
	}

	.hooper-pagination .hooper-indicators .hooper-indicator {
		border: none;
		background-color: rgb(170, 170, 170) !important;
	}

	.hooper-pagination .hooper-indicators .hooper-indicator.is-active {
		background-color: rgb(0, 0, 0) !important;
	}
}
</style>
